import { render, staticRenderFns } from "./2Step.vue?vue&type=template&id=37427676&scoped=true&"
import script from "./2Step.vue?vue&type=script&lang=js&"
export * from "./2Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37427676",
  null
  
)

export default component.exports